import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import SearchBar from './searchbar';
import DropDownMenu from '../dropdownmenu';
import withAuthProvider from '../../hoc/withAuthProvider';
import withFetch from '../../hoc/withFetch';
import logo from '../../images/logo2.png';
import CustomerService from '../customer-service';
import './styles.scss';
import BetaBar from '../beta-bar';

class Header extends Component {
    
    render() {
        return (
            <>
                <header className="header">
                    <BetaBar {...this.props} />
                    <div className="header__content">
                        <Link to="/" className="header__logo">
                            <img src={logo} alt="" />
                        </Link>
                        <>
                            <div className={classNames({
                                'search-bar-outer': true
                            })}>
                                {this.props.roles && this.props.roles.menuItems.indexOf('Delfiregister') > -1 &&
                                    <SearchBar {...this.props} />
                                }
                            </div>
                            <span className={classNames({
                                'header__cat-link-outer': true
                            })}>
                                {this.props.roles && this.props.roles.menuItems.indexOf('Delfiregister') > -1 &&
                                    <Link className="header__cat-link" to="/categories">Utforska kategorier</Link>
                                }
                            </span>
                        </>
                        <CustomerService />
                        <DropDownMenu text={this.props.user && this.props.user.name} {...this.props} />
                    </div>
                </header>
            </>
        );
    }
    
};

export default withAuthProvider(withFetch(Header));